<template>
  <footer class="NavBar-wrapper">
    <div class="NavBar-inner">
      <div class="swiper-container">
        <div class="swiper-wrapper swiper-wrappers">
          <div class="swiper-slide" v-for="item in menuList" :key="item.id">
            <!-- 每个子导航name -->
            <div class="NavBar-item" :class="[item.active && 'active', 'NavBar-item' + item.id]">
              <div class="NavBar-item-name" :class="['NavBar-item-name' + item.id]" @click="goPage(item,$event)">{{ item.name }}</div>
              <!-- 每个子导航的子list列表 -->
              <!-- v-if="item.subMenus && item.active" -->
              <ul v-if="item.subMenus">
                <li v-for="subItem in item.subMenus" :class="[subItem.active && 'active']" :key="subItem.id">
                  <a @click="goPage(subItem)" href="javascript:;">{{ subItem.name }}</a>
                </li>
              </ul>
              <div :class="{'activeLine': item.active}">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.css'

import Config from '@/utils/config'

import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {}
  },
  name: 'NabBar',
  computed: {
    ...mapState(['lang', 'menuList', 'pathName']),
    SubListRefs (id) {
      return 'SubListRef' + id
    }
  },
  created () {
    this.getMenu()
  },
  watch: {
    menuList (val) {
      if (val && val.length) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.slide()
          }, 200)
        })
      }
    },
    $route () {
      this.setMenuList(this.formatMenus(this.menuList))
    }
  },
  methods: {
    ...mapMutations(['setMenuList', 'setShowLoading']),
    // 获取导航数据
    getMenu () {
      this.$Api.getMenu({}).then((data) => {
        if (data) {
          const menus = data.menus
          if (menus && menus.length) {
            this.setMenuList(this.formatMenus(menus))
          }
        }
      })
    },
    // 格式化数据
    formatMenus (menus) {
      menus.map((val, idx) => {
        val.linkUrl && (val.linkUrl = this.pcLinkTowap(val.linkUrl))
        if (val.linkUrl && !/channel\/\d+$/.test(val.linkUrl)) {
          val.active = this.menuActive(val.linkUrl)
        } else {
          val.active = this.$router.history.current.path.includes(val.channelId)
        }
        if (val.subMenus && val.subMenus.length) {
          val.subMenus.map((subVal, subIndex) => {
            subVal.linkUrl &&
              (subVal.linkUrl = this.pcLinkTowap(subVal.linkUrl))
            subVal.active = subVal.linkUrl
              ? this.menuActive(subVal.linkUrl)
              : false
            if (subVal.active) {
              val.active = true
            }
          })
        }
        return val
      })
      return menus
    },
    pcLinkTowap (link) {
      let path = ''
      if (
        this.$Common.isHyperlinks(link) &&
        link.indexOf(Config.yzgUrl) < 0 &&
        link.indexOf(Config.ylyzgUrl) < 0
      ) {
        path =
          link.split(Config.pcDomain)[1] ||
          link.split(Config.pcEnDomain)[1] ||
          link
      } else {
        path = link
      }
      for (const key in Config.pcPage) {
        const val = Config.pcPage[key]
        const pathArr = path.split('/')
        const id = parseInt(pathArr[pathArr.length - 1])
        const pathName = id
          ? pathArr.splice(1, pathArr.length - 2).join('/')
          : pathArr.splice(1, pathArr.length - 1).join('/')
        if (pathName === `${val}`) {
          path = !id ? `/${key}` : `/${key}/${id}`
          break
        }
      }
      if (
        this.$Common.isHyperlinks(path) &&
        path.indexOf(Config.wapDomain) > -1
      ) {
        path = path.split(Config.wapDomain)[1] || '/'
      }
      return path
    },
    // 导航页面跳转
    goPage (item, e) {
      const showList = document.getElementsByClassName('show')
      const link = item.linkUrl
      // 尝试解决方法1
      // 无link 无子菜单 无频道id
      if ((!link && !item.subMenus && !item.channelId)) {
        if (showList.length) {
          for (let i = 0; i < showList.length; i++) {
            showList[i].className = ''
          }
        }
        this.$toast('无页面')
      } else if (link && this.$Common.isHyperlinks(link)) {
        // 有link，并且是链接
        window.location.href = link
      } else if (link) {
        if (showList.length) {
          for (let i = 0; i < showList.length; i++) {
            showList[i].className = ''
          }
        }
        this.$router.push(link)
      } else if (!item.channelId && item.subMenus) {
        // 无频道id 有子菜单
        const subNode = e.currentTarget.nextSibling
        if (subNode.className === 'show') {
          subNode.className = ''
        } else {
          if (showList.length) {
            for (let i = 0; i < showList.length; i++) {
              showList[i].className = ''
            }
          }
          subNode.className = 'show'
        }
      } else if (item.channelId && item.subMenus) {
        // 有频道id 有子菜单
        // 有频道id
        // this.$router.push({
        //   path: `/channel/${item.id}`,
        //   query: { id: item.id, name: item.name, lan: this.lang, channelId: item.channelId }
        // })
        // 有子菜单
        const subNode = e.currentTarget.nextSibling
        if (subNode.className === 'show') {
          subNode.className = ''
        } else {
          const showList = document.getElementsByClassName('show')
          if (showList.length) {
            for (let i = 0; i < showList.length; i++) {
              showList[i].className = ''
            }
          }
          subNode.className = 'show'
        }
      } else if (item.channelId) {
        for (let i = 0; i < showList.length; i++) {
          showList[i].className = ''
        }
        // 有频道id
        this.$router.push({
          path: `/channel/${item.channelId}`,
          query: { id: item.id, name: item.name, lan: this.lang, channelId: item.channelId }
        })
      }
    },
    // 导航是否是选中状态
    menuActive (url) {
      if (url && url.split('?')[0] === this.pathName) {
        return true
      }
      return false
    },
    // showSubList (e) {
    //   const subNode = e.currentTarget.nextSibling
    //   if (subNode.className === 'show') {
    //     subNode.className = ''
    //   } else {
    //     const showList = document.getElementsByClassName('show')
    //     if (showList.length) {
    //       for (let i = 0; i < showList.length; i++) {
    //         showList[i].className = ''
    //       }
    //     }
    //     subNode.className = 'show'
    //   }
    // },
    slide () {
      // eslint-disable-next-line no-new
      new Swiper('.NavBar-wrapper .swiper-container', {
        loop: false, // 循环
        slidesPerView: 'auto', // 自动匹配宽度
        freeMode: true, // 撞击反弹
        autoPlay: false // 回调函数，在slide自动切换开始时执行
        // centeredSlides: true // 页面居中

      })
    }
  }
}
</script>

<style lang="scss"  >
.NavBar-wrapper {
  // background: linear-gradient(180deg, #3a62d3 0%, #1b33a7 100%);
  background: #002eaa;
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 10.3vw;
  left: 0;
  top: 10.4vw;
  .NavBar-inner {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .swiper-container {
    overflow: visible;
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    flex: 1;
    margin: 0;
    width: auto;
  }
  .NavBar-item {
    height: 100%;
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2vw;
    min-width: 20vw;
    box-sizing: border-box;
    &.active {
      font-weight: bold;
      color: #ffffff;
    }
    .activeLine {
      position: absolute;
      bottom: 0;
      width: 10.67vw;
      height: 0.8vw;
      background: #ea5f00;
    }
    .NavBar-item-name {
      color: #ffffff;
      font-size: 3.704vw;
      line-height: 1.4;
      white-space: nowrap;
      opacity: 0.8;
    }
    &.active {
      .NavBar-item-name {
        opacity: 1;
      }
    }
    ul {
      transform: translateX(-50%) scale(0);
      transform-origin: center top;
      position: absolute;
      top: 10vw;
      left: 50%;
      transition: transform 0.3s;
      background-color: #fff;
      border-radius: 0.926vw;
      padding: 0.926vw 2.778vw;
      box-shadow: 0 0 3vw #ccc;
      &.show {
        transform: translateX(-50%) scale(1);
      }
      &::after {
        content: "";
        position: absolute;
        top: -3.8vw;
        left: 50%;
        transform: translateX(-50%) rotate(180deg);
        width: 0;
        height: 0;
        border: 2vw solid;
        border-color: #fff transparent transparent transparent;
      }
      li {
        border-bottom: 1px solid #878787;
        &:last-child {
          border-bottom: none;
        }
        a {
          font-size: 3.611vw;
          line-height: 1.4;
          color: #1b33a7;
          text-decoration: none;
          padding: 1.667vw 0;
          display: block;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
